import { AlertTriangle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from './alert'

interface AlertWarningProps {
  title?: string
  children: React.ReactNode
}

export const AlertWarning = ({
  title = 'Atención',
  children,
}: AlertWarningProps) => {
  return (
    <Alert variant="warning">
      <AlertTitle className="flex items-center gap-2 text-md">
        <AlertTriangle className="h-5 w-5" />
        {title}
      </AlertTitle>
      <AlertDescription className="text-sm">
        {children}
      </AlertDescription>
    </Alert>
  )
}
